import { htmlCanvas } from "@foretagsplatsen/widgetjs";

export const activeCssClass = "active";

export const selectedCssClass = "selected";

/**
 * Update the select button with the selected item.
 * This is solely made for internal use.
 */
export function updateButtonLabelFromSelection({
	selectedItem,
	buttonRef,
	buttonLabelRef,
	emptyLabel,
	alwaysDisabled,
}) {
	renderContentOn({
		root: buttonLabelRef,
		content: selectedItem?.label ?? emptyLabel,
	});

	if (!alwaysDisabled) buttonRef.removeAttribute("disabled");
}

/**
 * Select an option within the select element.
 * This is solely made for internal use.
 */
export function selectOption({
	option,
	onChange,
	buttonLabelRef,
	emptyLabel,
	nodeToItem,
	clearSelectionRef,
}) {
	onChange(option?.value ?? null);

	if (option) {
		renderContentOn({ root: buttonLabelRef, content: option.label });
		clearSelectionRef?.classList.remove("is-not-visible");
	} else {
		renderContentOn({ root: buttonLabelRef, content: emptyLabel });
		clearSelectionRef?.classList.add("is-not-visible");
	}

	removeCssClass({ nodeToItem, cssClass: selectedCssClass });
}

/**
 * Remove a CSS class from all nodes.
 * This is solely made for internal use.
 *
 * @param {object} options - Object parameters
 * @param {Map} options.nodeToItem - The map of nodes to items
 * @param {string} options.cssClass - The CSS class to remove
 */
export function removeCssClass({ nodeToItem, cssClass }) {
	for (const previous of nodeToItem.keys()) {
		previous.classList.remove(cssClass);
	}
}

/**
 * Find the first selectable item.
 *
 * @param {Array} items - The items to search
 * @return {any}
 */
export function firstSelectableItem(items) {
	for (const item of items) {
		if (!item.options && !item.disabled) {
			return item;
		}

		if (!item.disabled) {
			const found = firstSelectableItem(item.options);
			if (found) {
				return found;
			}
		}
	}

	return null;
}

/**
 * Find the selected item within the select items.
 * This is solely made for internal use.
 *
 * @param {object} options - Object parameters
 * @param {any[]} options.items - The items to search
 * @param {string} options.selected - The selected value
 * @return {any}
 */
export function findSelectedItem({ items, selected }) {
	const { selection, candidate } = _findSelectedItem({
		items,
		selected,
	});

	return selection || candidate;
}

function _findSelectedItem({ items, selected }) {
	let selectedCandidate = null;
	for (const item of items) {
		if (item.value === selected) {
			return { selection: item };
		}

		if (item.options) {
			const found = _findSelectedItem({ items: item.options, selected });
			if (found.selection) {
				return found;
			}

			if (found.candidate) {
				selectedCandidate = found.candidate;
			}
		} else if (item.selected && !selectedCandidate) {
			selectedCandidate = item;
		}
	}

	return { candidate: selectedCandidate };
}

/**
 * Todo: Add JSDoc comment
 */
export function registerSmartOnBlur({ buttonRef, onBlur }) {
	const callback = (event) => {
		if (event.target && buttonRef.contains(event.target)) {
			return;
		}
		onBlur();
	};

	document.body.addEventListener("click", callback);

	return callback;
}

/**
 * Todo: Add JSDoc comment
 */
export function makeNodeActive({ node, nodeToItem }) {
	if (node.classList.contains(activeCssClass)) return;
	removeCssClass({ nodeToItem, cssClass: activeCssClass });
	node.classList.add(activeCssClass);
}

/**
 * Todo: Add JSDoc comment
 */
export function renderContentOn({ root, content }) {
	root.innerHTML = "";
	htmlCanvas(root).render(content);
}
